import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionVoiceAndToneHuman = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"type": "page",
			"properties": {
				"title": [
					[
						"Пишем для человека"
					]
				]
			},
			"content": [
				"ff67283b-13e5-453c-b9d9-e8e094d40253",
				"0ff023fd-94da-4a2c-8539-8f2f0855ef26",
				"43bfbbce-d7b9-4a82-b1df-63c34b174085",
				"2db185d3-9fb4-4189-aa50-526e86160407",
				"4d409c22-0f36-450b-9b83-5c63372af631",
				"c51143dc-957e-4bd9-841e-0027fdf6ca67",
				"48c0923c-1ee4-42ed-b460-27b03f121b13",
				"27b8b465-2ea8-4f63-b5a8-32604904f34b",
				"a304c291-769b-4e2c-bf8f-008f22def450",
				"bc955139-f03a-484a-99c0-9aef10cbd2ea",
				"ff8a8f4d-756e-4b64-beda-f4e84bd2bc29",
				"2e9d20ac-1728-40f2-854c-e31bae9a089d",
				"6317ec1d-148b-4fa6-9433-079ef33dd461",
				"e63e1b14-ff2c-4dac-8bdb-21f9115c56bb",
				"0288d02a-5324-4655-9cb5-f9aee01bed66",
				"4c906378-e5ef-4e7e-8437-ee1c982c3618",
				"35f46d58-73a2-4380-b904-1f1a26e8dbd9",
				"a15d775f-2c36-4999-85c6-9b985bd72e89",
				"e9fe97f4-4e96-4ced-98b8-9ce88aa02721",
				"786678f3-ce05-4fde-9f49-6070ca0b08b4",
				"55459771-ad1f-496e-a1a0-30faa49fb630",
				"5df160e9-217c-47a0-9150-b4c33b736c8a",
				"fc3c1a58-8449-4f33-807f-bf93b77ca317",
				"2d075ccd-2a32-4f8d-867f-4a12a5d95a05",
				"bece1a59-ee0c-4361-aedc-46e65a2267a6",
				"dca2fd34-31dc-4e60-a499-d527b7d07dd4",
				"6d21d249-cc8c-465f-a299-5edaf1cc4a41",
				"51612297-ff80-4d38-a8c0-f799e7b23cff",
				"13829c94-db41-4feb-b8ff-73f6750b27b6",
				"de10450c-7b14-48c0-984c-f486ab7863f4",
				"fd170406-e8ed-4fed-9bca-bc6b610d2855",
				"9a693ede-fceb-4877-bb7d-6e88dce607de",
				"920694bf-ef01-424e-ab02-80646f7077e6",
				"2dc4e27f-c8be-49ec-8928-c5c62cfb7ecb",
				"688143be-2672-4e88-a4a7-4ac39822aa97",
				"80f75460-ffec-4389-9ab8-dddbcf3ebd04",
				"574bf2e0-de51-42c9-a3c0-e536ca7583f1",
				"f73bb041-a036-4e72-9ced-8432fe4fa003",
				"401461d7-c2d2-43ae-9d99-1fc59f736bda",
				"61c71873-4bc6-40cd-94fd-d6ecbfa627b3",
				"8599733d-a64d-4907-814d-1898fcf95d65",
				"efcb2141-66d9-452b-8e61-7f9267befde3",
				"4672f863-0e41-41e7-8504-a7b5dd2e6fcd",
				"86e36059-64e1-4031-8514-007d3c4420f1"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ff67283b-13e5-453c-b9d9-e8e094d40253",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/voice_and_tone/human\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "eee82228-305a-43ad-b48e-7daf90a49a04",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0ff023fd-94da-4a2c-8539-8f2f0855ef26",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наши пользователи — обычные люди. Независимо от образования, профессии, опыта, насмотренности и массы личностных качеств, человек ищет простое решение своих задач.\nНам важно думать о его потребностях и создавать человекоцентричный сервис. Сокращать разрыв между живыми потребностями и решениями в цифровой среде."
					]
				]
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "43bfbbce-d7b9-4a82-b1df-63c34b174085",
			"type": "text",
			"properties": {
				"title": [
					[
						"Поэтому мы:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "40ea2625-8be6-46f0-90f1-66315ab0f74f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2db185d3-9fb4-4189-aa50-526e86160407",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"ставим человека в центр — думаем о нём в первую очередь"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a82db361-9262-4d07-82c9-3fbe0ecf9351",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4d409c22-0f36-450b-9b83-5c63372af631",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"выступаем в роли надёжного партнёра"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "92b18b91-eccd-4baa-bb13-bac2406dd95b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c51143dc-957e-4bd9-841e-0027fdf6ca67",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"мотивируем, поддерживаем, бережно направляем"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d56882ae-4bf8-45f3-a566-2eea2c8bfb8f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "48c0923c-1ee4-42ed-b460-27b03f121b13",
			"type": "header",
			"properties": {
				"title": [
					[
						"Человек в продукте "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a664b3f6-b49f-46b9-a8ed-a0bfb6dc5299",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "27b8b465-2ea8-4f63-b5a8-32604904f34b",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не юзер, пользователь, клиент — человек"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8e8ba1d6-4562-47dd-93e9-efe4106342c2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a304c291-769b-4e2c-bf8f-008f22def450",
			"type": "text",
			"properties": {
				"title": [
					[
						"Человекоцентричность — принцип, которому мы следуем. Человек остаётся человеком, какую бы роль он ни принимал в контексте. Он может быть клиентом, покупателем, пользователем — но в первую очередь он человек. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5826e6b9-e1ae-427b-9387-5a037707c9fc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bc955139-f03a-484a-99c0-9aef10cbd2ea",
			"type": "column_list",
			"content": [
				"ce95d12f-b33d-4555-9efd-77ff4927729b",
				"4b3a035f-f3b2-4db4-b168-233f70c04eb3"
			],
			"format": {
				"copied_from_pointer": {
					"id": "65e75459-7476-4ad4-9424-3f2240ed6de2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ff8a8f4d-756e-4b64-beda-f4e84bd2bc29",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Идём от пользы и выгоды для человека "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "59d0cbc4-db24-4c2f-b7b0-cb4984d0defa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2e9d20ac-1728-40f2-854c-e31bae9a089d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Каким бы сервис ни был технологичным, современным — на первом месте не он, а человек со своими заботами, желаниями, потребностями. Думаем и говорим о пользе и объясняем выгоду.    "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "353c1576-2504-499e-8a7a-05b2f1ac27b6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6317ec1d-148b-4fa6-9433-079ef33dd461",
			"type": "column_list",
			"content": [
				"58de030c-6337-49ca-b656-2b37b1f46510",
				"5aa5fa0b-2c8b-49c8-8c05-e150e7199c8b"
			],
			"format": {
				"copied_from_pointer": {
					"id": "7132e8cc-e122-4ce4-b30b-2d2bc12ab7cf",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e63e1b14-ff2c-4dac-8bdb-21f9115c56bb",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Используем юзкейсы  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0bd84745-492d-4af2-986c-8a97d1885013",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0288d02a-5324-4655-9cb5-f9aee01bed66",
			"type": "text",
			"properties": {
				"title": [
					[
						"Примеры из жизни — лучший способ погрузить в контекст, подсветить потребность, акцентировать внимание человека. Юзкейс должен быть «живым», не искусственным или притянутым. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5523ed84-ef43-4ea9-aab4-e374c4b665b1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4c906378-e5ef-4e7e-8437-ee1c982c3618",
			"type": "column_list",
			"content": [
				"7b51231b-1dd3-44f8-aec6-9485e40d353d",
				"c3253e27-9fd6-43be-87f0-4f3f3454e022"
			],
			"format": {
				"copied_from_pointer": {
					"id": "63052a1d-bee2-4eca-826c-3ea1f5ddf47c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "35f46d58-73a2-4380-b904-1f1a26e8dbd9",
			"type": "header",
			"properties": {
				"title": [
					[
						"Продукт для человека "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "af452bde-8496-44ee-a958-a45dda420116",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a15d775f-2c36-4999-85c6-9b985bd72e89",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Говорим как люди  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e21ea004-8661-4ee7-bcfd-11e9b980f946",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e9fe97f4-4e96-4ced-98b8-9ce88aa02721",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы не используем канцелярит, клише, профессиональную терминологию, объясняем сложное и приземляем любую функцию на опыт человека — то есть говорим как люди. Бережно, уважительно, тепло и внимательно. Не сюсюкаемся, остаёмся на равных.  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5c61dcf4-40f9-4dbe-9c0f-1d3402300346",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "786678f3-ce05-4fde-9f49-6070ca0b08b4",
			"type": "column_list",
			"content": [
				"6a909df5-8004-495c-8178-c355dd6aa154",
				"46f2c748-bb39-4bc1-8808-433a7215fcc4"
			],
			"format": {
				"copied_from_pointer": {
					"id": "a4b34e08-e26d-4b68-aa32-9424a573e08b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "55459771-ad1f-496e-a1a0-30faa49fb630",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не путаем: команда — мы, интерфейс — без лица "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8219411c-63f0-4e5b-94f8-c4bb55855e23",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5df160e9-217c-47a0-9150-b4c33b736c8a",
			"type": "text",
			"properties": {
				"title": [
					[
						"В коммуникации мы можем показать лицо команды и говорить от лица «мы». Интерфейс же не одушевлён — он подсказывает и ведёт по сценарию обезличенно. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "26de9f00-a59b-49af-979c-94d5673a3ceb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fc3c1a58-8449-4f33-807f-bf93b77ca317",
			"type": "text",
			"properties": {
				"title": [
					[
						"Исключения ",
						[
							[
								"b"
							]
						]
					],
					[
						"\nПри появлении героя, как, например, в спецпроекте с Роботом GPT — появляется коммуникация от его лица. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2e8fdbd0-56ba-4e73-9872-0e7ce5c44893",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2d075ccd-2a32-4f8d-867f-4a12a5d95a05",
			"type": "column_list",
			"content": [
				"63193a37-b22e-495c-b980-51103c18f8a1",
				"1d7fd7c5-be5d-4790-9566-c532e0c93394"
			],
			"format": {
				"copied_from_pointer": {
					"id": "06ef8be4-cf8d-4d2f-8dd3-66e9b07e7193",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bece1a59-ee0c-4361-aedc-46e65a2267a6",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не сомневаемся в способностях и силе человека "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a1c62814-6e5d-4780-b94a-2fbf1e13149b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dca2fd34-31dc-4e60-a499-d527b7d07dd4",
			"type": "text",
			"properties": {
				"title": [
					[
						"Не переходим границы, не инвалидизируем и всегда помним — по ту сторону экрана обычный человек.  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f395f4ce-be23-4252-81f1-bd3771e166e0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6d21d249-cc8c-465f-a299-5edaf1cc4a41",
			"type": "column_list",
			"content": [
				"bce5df38-c46d-4cfb-ab07-513e48681186",
				"5e052514-b466-42bf-992c-6fdc993ef8d4"
			],
			"format": {
				"copied_from_pointer": {
					"id": "c57121c6-95ab-49c0-9986-369860bc6209",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "51612297-ff80-4d38-a8c0-f799e7b23cff",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Отвечаем на вопросы, а не задаём"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8b918cda-9ffc-44e8-9f85-1bae46baf99c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "13829c94-db41-4feb-b8ff-73f6750b27b6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Человек приходит в сервис, чтобы решить свою задачу — от утилитарной\nдо развлекательной. Вопрос может быть уместен только в той части интерфейса, где мы хотим подсветить важность действия, например, удаление файла. В остальных случаях стараемся выходить с готовым решением. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1ed80fc0-cf23-4466-9d69-988a00aac42b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "de10450c-7b14-48c0-984c-f486ab7863f4",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Исключение:",
						[
							[
								"i"
							]
						]
					],
					[
						" в маркетинговой коммуникации вопросительная интонация может быть удачным заходом. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3159f385-f467-49f8-b31d-e567a49201c9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fd170406-e8ed-4fed-9bca-bc6b610d2855",
			"type": "column_list",
			"content": [
				"00e55b0a-8d4f-4ede-86bd-b4f93adc52ee",
				"9a9ec39b-2021-426f-b9f3-cd70553005dc"
			],
			"format": {
				"copied_from_pointer": {
					"id": "743fd654-b285-4630-b893-4068c77f380e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9a693ede-fceb-4877-bb7d-6e88dce607de",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Делимся полезными советами "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "54597ba2-4466-403a-8b4f-254f55863413",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "920694bf-ef01-424e-ab02-80646f7077e6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Кроме основных функций, в сервисах есть много всего, что поможет пользователям решать свои задачи ещё быстрее. Подсвечиваем их также по принципу: сначала человек, потом фича.   "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6ef7ce1d-7b90-471f-a427-2796b68c767e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2dc4e27f-c8be-49ec-8928-c5c62cfb7ecb",
			"type": "column_list",
			"content": [
				"61dd5668-57e0-42dc-a4b5-ad88989686b0",
				"95593ffe-78b0-4c5a-bf09-e3bf78fcd8b5"
			],
			"format": {
				"copied_from_pointer": {
					"id": "cdeac5c1-1a22-4a30-bcd3-b018e7fd4537",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "688143be-2672-4e88-a4a7-4ac39822aa97",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Гордимся, но не кичимся "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a680e1fd-0bc4-4363-939a-cf448df7e6bb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "80f75460-ffec-4389-9ab8-dddbcf3ebd04",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы появились одновременно с Рунетом и ценим свой опыт, но не кичимся им. Делимся знаниями, подсказываем, бережно направляем. Делаем это с заботой и так, чтобы пользователь никогда не чувствовал себя глупым или в подчинённом положении.   "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9a89df9e-b666-4b11-81ce-52fed9fba0f9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "574bf2e0-de51-42c9-a3c0-e536ca7583f1",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21f2b8d6-0522-4d43-bd81-c485bacc732f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21f2b8d6-0522-4d43-bd81-c485bacc732f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"file_ids": [
				"21f2b8d6-0522-4d43-bd81-c485bacc732f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/574bf2e0-de51-42c9-a3c0-e536ca7583f1.png"
		},
		{
			"id": "f73bb041-a036-4e72-9ced-8432fe4fa003",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Вам нет равных по безопасности. Рассказываем, как вы помогаете защищать Почту на все 100, и что мы делаем для этого сами \n\nСамая популярная почта России: 25 млн человек пользуются Почтой ежедневно, а 20 — отправляют письма каждый день"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "81796e0a-ef56-448c-af37-84868f003c83",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "401461d7-c2d2-43ae-9d99-1fc59f736bda",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Нет ничего невозможного   "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e7fed58e-2834-410f-bc0d-66e242852c9e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "61c71873-4bc6-40cd-94fd-d6ecbfa627b3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Начинать коммуникацию с «нет», «нельзя», «невозможно», что в обычной жизни,\nчто в интерфейсе — плохой тон. Даже если какое-то действие человек выполнить \nне сможет — объясняем, что сделать можно, подсвечиваем возможности. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "346d6137-7f74-4e99-b3e0-73c2efccfc66",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8599733d-a64d-4907-814d-1898fcf95d65",
			"type": "column_list",
			"content": [
				"466adac9-fae1-46ae-99af-6ccdc5bc216d",
				"0fd47fe2-7697-4680-a6a3-e1b82ce4a70f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "5f9df517-58c8-48ef-a247-19b20f44e71d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "efcb2141-66d9-452b-8e61-7f9267befde3",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не ставим условий "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "04220e69-6653-46b3-80c0-10cffc81a37c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4672f863-0e41-41e7-8504-a7b5dd2e6fcd",
			"type": "text",
			"properties": {
				"title": [
					[
						"Коммуникация со «чтобы», «если» — часто звучит высокомерно и приказательно. Начинаем с утверждения и объяснения пользы.  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7ca6a0e3-305a-4e77-9b8f-1d2443ff6327",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "86e36059-64e1-4031-8514-007d3c4420f1",
			"type": "column_list",
			"content": [
				"937298aa-76e4-4e94-ad85-2abf7c767851",
				"eba466a5-1f1f-4740-8fce-8ef2bba332a0"
			],
			"format": {
				"copied_from_pointer": {
					"id": "f915969c-8961-4d31-9eef-943d0cc39d13",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ce95d12f-b33d-4555-9efd-77ff4927729b",
			"type": "column",
			"content": [
				"4ace73e1-8a09-4023-8ee8-a08c4bacda70",
				"09206aee-33df-4d2c-83f6-d6635e48ec61"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "744f7f00-cb7e-4609-bf22-7b15dcf4c0e0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bc955139-f03a-484a-99c0-9aef10cbd2ea",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4b3a035f-f3b2-4db4-b168-233f70c04eb3",
			"type": "column",
			"content": [
				"3c14eff2-0fe9-48b6-a38f-18c2f5b2fd60",
				"3db6aa92-ca42-4861-b19e-8395b2bb5a31"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "b5646cdd-8b56-4488-bcc8-854ebe193300",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bc955139-f03a-484a-99c0-9aef10cbd2ea",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4ace73e1-8a09-4023-8ee8-a08c4bacda70",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6d8710b8-4940-420b-a4d7-1e4e253385bc/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6d8710b8-4940-420b-a4d7-1e4e253385bc/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "ce95d12f-b33d-4555-9efd-77ff4927729b",
			"parent_table": "block",
			"file_ids": [
				"6d8710b8-4940-420b-a4d7-1e4e253385bc"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4ace73e1-8a09-4023-8ee8-a08c4bacda70.png"
		},
		{
			"id": "09206aee-33df-4d2c-83f6-d6635e48ec61",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Теперь в Облаке на компьютере можно работать в документах \nи таблицах с другими людьми"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a4c073d3-d6be-4b8d-919e-eeb91db9fab4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ce95d12f-b33d-4555-9efd-77ff4927729b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3c14eff2-0fe9-48b6-a38f-18c2f5b2fd60",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f8366712-4087-48a2-986c-47d272908b08/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f8366712-4087-48a2-986c-47d272908b08/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "4b3a035f-f3b2-4db4-b168-233f70c04eb3",
			"parent_table": "block",
			"file_ids": [
				"f8366712-4087-48a2-986c-47d272908b08"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3c14eff2-0fe9-48b6-a38f-18c2f5b2fd60.png"
		},
		{
			"id": "3db6aa92-ca42-4861-b19e-8395b2bb5a31",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Теперь в Облаке \nна компьютере можно редактировать \nи комментировать текстовые документы и таблицы с другими пользователями"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "99e9a6c7-9cb3-4720-a88a-c123c72b44c8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4b3a035f-f3b2-4db4-b168-233f70c04eb3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "58de030c-6337-49ca-b656-2b37b1f46510",
			"type": "column",
			"content": [
				"6530dc31-9797-412f-9c90-fc8433a9d669",
				"6e45066c-feb7-491d-a478-925921975f77"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "8bcddff8-0a62-4dfd-ae96-8903426a2f43",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6317ec1d-148b-4fa6-9433-079ef33dd461",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5aa5fa0b-2c8b-49c8-8c05-e150e7199c8b",
			"type": "column",
			"content": [
				"1575ae57-418b-4de5-9b68-aa5d4c064c64",
				"a486f497-8cf5-4df0-a6d5-8a7ce2a11f5f"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "c04d5f84-9d1e-415c-aff4-0a0c72e25fc4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6317ec1d-148b-4fa6-9433-079ef33dd461",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6530dc31-9797-412f-9c90-fc8433a9d669",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e4aa8691-083a-4fe1-b3ae-c61ae62697d6/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e4aa8691-083a-4fe1-b3ae-c61ae62697d6/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "58de030c-6337-49ca-b656-2b37b1f46510",
			"parent_table": "block",
			"file_ids": [
				"e4aa8691-083a-4fe1-b3ae-c61ae62697d6"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6530dc31-9797-412f-9c90-fc8433a9d669.png"
		},
		{
			"id": "6e45066c-feb7-491d-a478-925921975f77",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Настройте Календарь для себя: планируйте дни, настраивайте напоминания \n\nЧеки, статусы на Госуслугах \nи скидки — с умной сортировкой всё по полочкам"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "1a449779-3f55-4a2a-b6f5-92febbe5615c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "58de030c-6337-49ca-b656-2b37b1f46510",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1575ae57-418b-4de5-9b68-aa5d4c064c64",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a13d6baf-47cd-441f-8535-15e721ac099b/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a13d6baf-47cd-441f-8535-15e721ac099b/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "5aa5fa0b-2c8b-49c8-8c05-e150e7199c8b",
			"parent_table": "block",
			"file_ids": [
				"a13d6baf-47cd-441f-8535-15e721ac099b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/1575ae57-418b-4de5-9b68-aa5d4c064c64.png"
		},
		{
			"id": "a486f497-8cf5-4df0-a6d5-8a7ce2a11f5f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Мы запустили новый \nКалендарь — красивый, стильный, удобный\n\nМетатреды — уникальная функция Почты"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "eaf4bc10-30e7-4acd-9fcd-bfbbb835953f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "5aa5fa0b-2c8b-49c8-8c05-e150e7199c8b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7b51231b-1dd3-44f8-aec6-9485e40d353d",
			"type": "column",
			"content": [
				"86d8cb4f-1c25-4f65-8fdb-8fa4fdc9763d",
				"59338a92-0902-463f-a605-6b295a281efe"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "83b43efc-d1d5-4a0b-b9f5-ee4d983fcdcc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4c906378-e5ef-4e7e-8437-ee1c982c3618",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c3253e27-9fd6-43be-87f0-4f3f3454e022",
			"type": "column",
			"content": [
				"81f2a421-7d23-4474-bc67-5c575fea82ba",
				"254c848e-8c1a-4ba6-a4aa-20bfcdbbb1fb"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "31ba456f-049e-4497-a38a-f78bb3017b3a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4c906378-e5ef-4e7e-8437-ee1c982c3618",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "86d8cb4f-1c25-4f65-8fdb-8fa4fdc9763d",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0259fd45-30be-48c6-a0b4-c38d8daf2008/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0259fd45-30be-48c6-a0b4-c38d8daf2008/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "7b51231b-1dd3-44f8-aec6-9485e40d353d",
			"parent_table": "block",
			"file_ids": [
				"0259fd45-30be-48c6-a0b4-c38d8daf2008"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/86d8cb4f-1c25-4f65-8fdb-8fa4fdc9763d.png"
		},
		{
			"id": "59338a92-0902-463f-a605-6b295a281efe",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Просят паспорт? Найдите \nскан — очередь даже не заметит\n\n\n«Не забыть полить цветы» — настройте регулярные события в Календаре  "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a005f8a0-dc8f-4998-978c-01117cd25577",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7b51231b-1dd3-44f8-aec6-9485e40d353d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "81f2a421-7d23-4474-bc67-5c575fea82ba",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a6179477-4588-43f4-bfdb-4c0f01709129/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a6179477-4588-43f4-bfdb-4c0f01709129/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "c3253e27-9fd6-43be-87f0-4f3f3454e022",
			"parent_table": "block",
			"file_ids": [
				"a6179477-4588-43f4-bfdb-4c0f01709129"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/81f2a421-7d23-4474-bc67-5c575fea82ba.png"
		},
		{
			"id": "254c848e-8c1a-4ba6-a4aa-20bfcdbbb1fb",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Создайте свою первую задачу —например, побывать во всех странах мира\n\nВесна — время фотографироваться "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "63520d2f-e8e6-47c9-ac0a-424d39eaf828",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c3253e27-9fd6-43be-87f0-4f3f3454e022",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6a909df5-8004-495c-8178-c355dd6aa154",
			"type": "column",
			"content": [
				"ebd558ed-7461-431c-a5e2-bfca66a359fd",
				"9f220a7a-3ae1-44a8-85d9-197000e31fa2"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "367c1aaa-e74d-4fd0-8f99-e160adceb21f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "786678f3-ce05-4fde-9f49-6070ca0b08b4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "46f2c748-bb39-4bc1-8808-433a7215fcc4",
			"type": "column",
			"content": [
				"98a3bf33-1106-48ac-b0cd-9d9d2307e2bc",
				"6d8f19fc-3bef-4d8a-854e-3b1a033f83c8"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "401bf637-da3a-4f3e-a263-61aa339d6820",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "786678f3-ce05-4fde-9f49-6070ca0b08b4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ebd558ed-7461-431c-a5e2-bfca66a359fd",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cbd75d0c-5273-4397-9929-88a7495b5793/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cbd75d0c-5273-4397-9929-88a7495b5793/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "6a909df5-8004-495c-8178-c355dd6aa154",
			"parent_table": "block",
			"file_ids": [
				"cbd75d0c-5273-4397-9929-88a7495b5793"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ebd558ed-7461-431c-a5e2-bfca66a359fd.png"
		},
		{
			"id": "9f220a7a-3ae1-44a8-85d9-197000e31fa2",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Ничего не нашлось. Проверьте, нет ли ошибки, или создайте новый запрос   "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "718fdf79-eeee-47b2-a7ec-3cbd0fcb0838",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6a909df5-8004-495c-8178-c355dd6aa154",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "98a3bf33-1106-48ac-b0cd-9d9d2307e2bc",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/37d9ef74-36a1-420d-8a26-76ef9c719e22/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/37d9ef74-36a1-420d-8a26-76ef9c719e22/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "46f2c748-bb39-4bc1-8808-433a7215fcc4",
			"parent_table": "block",
			"file_ids": [
				"37d9ef74-36a1-420d-8a26-76ef9c719e22"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/98a3bf33-1106-48ac-b0cd-9d9d2307e2bc.png"
		},
		{
			"id": "6d8f19fc-3bef-4d8a-854e-3b1a033f83c8",
			"type": "callout",
			"properties": {
				"title": [
					[
						"По запросу ничего не найдено. Проверьте правильность написания "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "22ddfd3c-a841-4e51-bdc5-13abf8752ee5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "46f2c748-bb39-4bc1-8808-433a7215fcc4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "63193a37-b22e-495c-b980-51103c18f8a1",
			"type": "column",
			"content": [
				"46ed718f-c37b-4180-92f0-5a38293c0070",
				"c9011d9d-ab1d-491b-8e46-5644b2ac31c3"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "ac0e46d9-68db-4988-82a9-11f665098417",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2d075ccd-2a32-4f8d-867f-4a12a5d95a05",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1d7fd7c5-be5d-4790-9566-c532e0c93394",
			"type": "column",
			"content": [
				"7387b909-b2eb-4285-aa57-da45fac4c497",
				"f7903613-c61a-40c8-9d5b-0f039903e6b4"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "963bf961-afca-40b5-90ac-e83de101c220",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2d075ccd-2a32-4f8d-867f-4a12a5d95a05",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "46ed718f-c37b-4180-92f0-5a38293c0070",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c4185c03-4be7-4981-b75c-6597323d2515/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c4185c03-4be7-4981-b75c-6597323d2515/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "63193a37-b22e-495c-b980-51103c18f8a1",
			"parent_table": "block",
			"file_ids": [
				"c4185c03-4be7-4981-b75c-6597323d2515"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/46ed718f-c37b-4180-92f0-5a38293c0070.png"
		},
		{
			"id": "c9011d9d-ab1d-491b-8e46-5644b2ac31c3",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Почта поможет разобрать рассылки\n\nПисьмо отправлено\n\nНаша команда говорит «спасибо»   "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "6444a27b-70a2-449a-b42f-88c9b3aaabdb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "63193a37-b22e-495c-b980-51103c18f8a1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7387b909-b2eb-4285-aa57-da45fac4c497",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e68decf5-3c3f-4904-80aa-17dae77979b7/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e68decf5-3c3f-4904-80aa-17dae77979b7/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "1d7fd7c5-be5d-4790-9566-c532e0c93394",
			"parent_table": "block",
			"file_ids": [
				"e68decf5-3c3f-4904-80aa-17dae77979b7"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/7387b909-b2eb-4285-aa57-da45fac4c497.png"
		},
		{
			"id": "f7903613-c61a-40c8-9d5b-0f039903e6b4",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Я помогу вам разобрать рассылки\n\nЯ отправила письмо \n\nКомандой сказано «спасибо» \nза ваш отзыв"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ad36eb6d-4b0f-4509-a3ed-dd535a267c3a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1d7fd7c5-be5d-4790-9566-c532e0c93394",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bce5df38-c46d-4cfb-ab07-513e48681186",
			"type": "column",
			"content": [
				"9bf2f52a-58f8-4b13-a221-7858ea9787d0",
				"8e7801ba-3f0d-42a3-8aa1-c6a64d5a8c69"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "af8af275-eece-444e-8680-90cadd21eaed",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6d21d249-cc8c-465f-a299-5edaf1cc4a41",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5e052514-b466-42bf-992c-6fdc993ef8d4",
			"type": "column",
			"content": [
				"d754d213-22ab-4195-832c-1c7f1403165f",
				"ed861e17-f23e-47e2-be1b-dd8d6998f1f3"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "5a3cfe60-761e-4448-ac7b-1e3aadc1bb7f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6d21d249-cc8c-465f-a299-5edaf1cc4a41",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9bf2f52a-58f8-4b13-a221-7858ea9787d0",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1fef81c2-32bd-4d4c-9fe5-5ba4160494c7/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1fef81c2-32bd-4d4c-9fe5-5ba4160494c7/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "bce5df38-c46d-4cfb-ab07-513e48681186",
			"parent_table": "block",
			"file_ids": [
				"1fef81c2-32bd-4d4c-9fe5-5ba4160494c7"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9bf2f52a-58f8-4b13-a221-7858ea9787d0.png"
		},
		{
			"id": "8e7801ba-3f0d-42a3-8aa1-c6a64d5a8c69",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Подтвердите, что действия\nвыполняете вы, а не робот\n\n"
					],
					[
						"Кнопка",
						[
							[
								"i"
							]
						]
					],
					[
						": Это я"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a9002912-1aaa-485e-8cff-56e055499565",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bce5df38-c46d-4cfb-ab07-513e48681186",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d754d213-22ab-4195-832c-1c7f1403165f",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b30bc02a-8b85-4fa4-b6e0-b060ad246764/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b30bc02a-8b85-4fa4-b6e0-b060ad246764/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "5e052514-b466-42bf-992c-6fdc993ef8d4",
			"parent_table": "block",
			"file_ids": [
				"b30bc02a-8b85-4fa4-b6e0-b060ad246764"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d754d213-22ab-4195-832c-1c7f1403165f.png"
		},
		{
			"id": "ed861e17-f23e-47e2-be1b-dd8d6998f1f3",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Вы точно человек?\nПройдите проверку \nдля подтверждения\n\n"
					],
					[
						"Кнопка",
						[
							[
								"i"
							]
						]
					],
					[
						": Я человек"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "3e77af40-3bce-4daa-8be5-6fc1edcf6238",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "5e052514-b466-42bf-992c-6fdc993ef8d4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "00e55b0a-8d4f-4ede-86bd-b4f93adc52ee",
			"type": "column",
			"content": [
				"cb153436-89e1-4a9f-a867-ca215df5b744",
				"951fef3c-0fae-4d45-88e6-8f2cdc74b36f"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "41fb5376-a3c0-472d-81f9-d8e93b9bd0c6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fd170406-e8ed-4fed-9bca-bc6b610d2855",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9a9ec39b-2021-426f-b9f3-cd70553005dc",
			"type": "column",
			"content": [
				"4f102acb-f80a-4cbf-800d-9cca1cf641eb",
				"244aa02c-3c2e-47d4-be49-71419d129619"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "840c98e9-a780-4ebc-aec9-4f785973a04f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fd170406-e8ed-4fed-9bca-bc6b610d2855",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cb153436-89e1-4a9f-a867-ca215df5b744",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/45cc0099-d8af-46d7-b4ee-62c03dcc7478/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/45cc0099-d8af-46d7-b4ee-62c03dcc7478/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "00e55b0a-8d4f-4ede-86bd-b4f93adc52ee",
			"parent_table": "block",
			"file_ids": [
				"45cc0099-d8af-46d7-b4ee-62c03dcc7478"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/cb153436-89e1-4a9f-a867-ca215df5b744.png"
		},
		{
			"id": "951fef3c-0fae-4d45-88e6-8f2cdc74b36f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Если письмо не пришло, нажмите кнопку"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d3f93a67-62bc-4918-8979-6b65889b06c9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "00e55b0a-8d4f-4ede-86bd-b4f93adc52ee",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4f102acb-f80a-4cbf-800d-9cca1cf641eb",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3725e74d-f29e-4d50-8222-ccf70213a08c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3725e74d-f29e-4d50-8222-ccf70213a08c/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "9a9ec39b-2021-426f-b9f3-cd70553005dc",
			"parent_table": "block",
			"file_ids": [
				"3725e74d-f29e-4d50-8222-ccf70213a08c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4f102acb-f80a-4cbf-800d-9cca1cf641eb.png"
		},
		{
			"id": "244aa02c-3c2e-47d4-be49-71419d129619",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Вам не пришло письмо? "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "9ae30be7-32b9-4a8b-a6ea-2b41e15033a3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9a9ec39b-2021-426f-b9f3-cd70553005dc",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "61dd5668-57e0-42dc-a4b5-ad88989686b0",
			"type": "column",
			"content": [
				"5202ff0c-db3c-4a9b-a2c7-1bc80938b1ac",
				"f5d8fb02-73ed-4e5f-a807-4ec10e1935ef"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "1c390768-f702-4612-aa56-34c1eb6d46eb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2dc4e27f-c8be-49ec-8928-c5c62cfb7ecb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "95593ffe-78b0-4c5a-bf09-e3bf78fcd8b5",
			"type": "column",
			"content": [
				"65664f0b-0188-46bd-8fe5-2f13aa306dea",
				"017a1331-ace3-48c8-96aa-3294c5d7fd19"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "e6091769-acbe-4c89-a5f5-9ecec13f4d92",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2dc4e27f-c8be-49ec-8928-c5c62cfb7ecb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5202ff0c-db3c-4a9b-a2c7-1bc80938b1ac",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3fee1b17-782e-41e4-92f4-639dfd4a84cb/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3fee1b17-782e-41e4-92f4-639dfd4a84cb/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "61dd5668-57e0-42dc-a4b5-ad88989686b0",
			"parent_table": "block",
			"file_ids": [
				"3fee1b17-782e-41e4-92f4-639dfd4a84cb"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5202ff0c-db3c-4a9b-a2c7-1bc80938b1ac.png"
		},
		{
			"id": "f5d8fb02-73ed-4e5f-a807-4ec10e1935ef",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Подсказка: вы можете читать входящие из всех ящиков \nв "
					],
					[
						"Mail.ru",
						[
							[
								"a",
								"http://Mail.ru",
								true
							]
						]
					],
					[
						" — настройте сборщик писем "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "585021a1-01d3-4a82-8e54-dca98a63b306",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "61dd5668-57e0-42dc-a4b5-ad88989686b0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "65664f0b-0188-46bd-8fe5-2f13aa306dea",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b3e497d9-ab15-4b9f-bd0c-b5385b1e4085/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b3e497d9-ab15-4b9f-bd0c-b5385b1e4085/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "95593ffe-78b0-4c5a-bf09-e3bf78fcd8b5",
			"parent_table": "block",
			"file_ids": [
				"b3e497d9-ab15-4b9f-bd0c-b5385b1e4085"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/65664f0b-0188-46bd-8fe5-2f13aa306dea.png"
		},
		{
			"id": "017a1331-ace3-48c8-96aa-3294c5d7fd19",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Новая функция в Почте —сборщик писем. Остальные ящики теперь не нужны "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "21ec365d-747f-4521-a2a4-24142ed2e71c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "95593ffe-78b0-4c5a-bf09-e3bf78fcd8b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "466adac9-fae1-46ae-99af-6ccdc5bc216d",
			"type": "column",
			"content": [
				"6142b085-07b1-4953-aece-c198e61c9a0b",
				"341f2c5a-4750-458d-86eb-390cc34b41c3"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "0f60b6cb-4c81-4290-ae70-96217f5f955c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8599733d-a64d-4907-814d-1898fcf95d65",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0fd47fe2-7697-4680-a6a3-e1b82ce4a70f",
			"type": "column",
			"content": [
				"4c640538-a0c9-4bd9-a556-74d2452ffecb",
				"9f391282-d5ca-4400-9dec-86af1357d6bd"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "2edf92a3-a97a-4f1e-b656-be9be911df28",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8599733d-a64d-4907-814d-1898fcf95d65",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6142b085-07b1-4953-aece-c198e61c9a0b",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cdee7342-89e5-452f-b5ed-8437de553a37/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cdee7342-89e5-452f-b5ed-8437de553a37/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "466adac9-fae1-46ae-99af-6ccdc5bc216d",
			"parent_table": "block",
			"file_ids": [
				"cdee7342-89e5-452f-b5ed-8437de553a37"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6142b085-07b1-4953-aece-c198e61c9a0b.png"
		},
		{
			"id": "341f2c5a-4750-458d-86eb-390cc34b41c3",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Файл в формате txt.ppt нельзя\nотправить. Переведите файл \nв другой формат"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5c7238ef-c8b1-458f-a2d2-8fdf5421b122",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "466adac9-fae1-46ae-99af-6ccdc5bc216d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4c640538-a0c9-4bd9-a556-74d2452ffecb",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cb78fb8f-3954-4460-8109-090fc526d9f1/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cb78fb8f-3954-4460-8109-090fc526d9f1/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "0fd47fe2-7697-4680-a6a3-e1b82ce4a70f",
			"parent_table": "block",
			"file_ids": [
				"cb78fb8f-3954-4460-8109-090fc526d9f1"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4c640538-a0c9-4bd9-a556-74d2452ffecb.png"
		},
		{
			"id": "9f391282-d5ca-4400-9dec-86af1357d6bd",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Невозможно загрузить файл txt.ppt "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "6d05728d-90e5-4baa-b9be-8d1bcfbc5867",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0fd47fe2-7697-4680-a6a3-e1b82ce4a70f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "937298aa-76e4-4e94-ad85-2abf7c767851",
			"type": "column",
			"content": [
				"6bf2a42a-94f4-42ef-a8cd-faf76920a831",
				"6bcd96fc-b7a3-4214-a5e9-483703d97d66"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "6e6e0164-0120-453a-a73f-d1f434ea090b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "86e36059-64e1-4031-8514-007d3c4420f1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eba466a5-1f1f-4740-8fce-8ef2bba332a0",
			"type": "column",
			"content": [
				"453ae02c-11eb-4e34-b8c4-6b2174154ec4",
				"b2e17b20-5bc1-4856-a7b7-8d39351d19f8"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "451559df-541a-4de2-9dd1-9785985ee968",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "86e36059-64e1-4031-8514-007d3c4420f1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6bf2a42a-94f4-42ef-a8cd-faf76920a831",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4c4a9d45-b377-43f0-844e-e468ef54a3b9/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4c4a9d45-b377-43f0-844e-e468ef54a3b9/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "937298aa-76e4-4e94-ad85-2abf7c767851",
			"parent_table": "block",
			"file_ids": [
				"4c4a9d45-b377-43f0-844e-e468ef54a3b9"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6bf2a42a-94f4-42ef-a8cd-faf76920a831.png"
		},
		{
			"id": "6bcd96fc-b7a3-4214-a5e9-483703d97d66",
			"type": "callout",
			"properties": {
				"title": [
					[
						"С подпиской к письму можно прикреплять файлы больше 25 МБ. Оформите пробный период за 1 ₽"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "852cfd9a-a1cb-47d0-a2d4-f1a75eb98139",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "937298aa-76e4-4e94-ad85-2abf7c767851",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "453ae02c-11eb-4e34-b8c4-6b2174154ec4",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f899a0c5-0508-464e-80b5-8ed1786e4260/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f899a0c5-0508-464e-80b5-8ed1786e4260/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "eba466a5-1f1f-4740-8fce-8ef2bba332a0",
			"parent_table": "block",
			"file_ids": [
				"f899a0c5-0508-464e-80b5-8ed1786e4260"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/453ae02c-11eb-4e34-b8c4-6b2174154ec4.png"
		},
		{
			"id": "b2e17b20-5bc1-4856-a7b7-8d39351d19f8",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Чтобы прикрепить файлы \nк письму больше 25 МБ — купите подписку "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d803f00f-5f83-4cfd-a2d6-c294a5008de7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "eba466a5-1f1f-4740-8fce-8ef2bba332a0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Человек в продукте ",
			"id": "48c0923c-1ee4-42ed-b460-27b03f121b13"
		},
		{
			"title": "Продукт для человека ",
			"id": "35f46d58-73a2-4380-b904-1f1a26e8dbd9"
		}
	]
}} />
);

export default NotionVoiceAndToneHuman;
